
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast({
      title: "Signal received",
      description: "You're on the list. Transmissions incoming.",
    });
    setEmail('');
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
      <Input
        type="email"
        placeholder="your@signal.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="bg-muted text-foreground border-0"
      />
      <Button type="submit" variant="outline" className="border-[#BFA181] text-[#BFA181] hover:bg-[#BFA181] hover:text-background">
        Transmit
      </Button>
    </form>
  );
};

export default NewsletterForm;
